module.exports = __webpack_public_path__ + "static/dalia-pugatsch-video-47e84f9d8829868cfba383f9646582e3.webm";